<template>
	<div class='footer'>
    	<p class="company_copyright">Copyright&copy; 2013-{{ yearTIme }} All Rights Reserved | 版权所有：真相网络科技（北京）有限公司 </p>
        <p class="company_copyright"> 京ICP备16033891号-2 | 公京检第1792001号  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037214"><i></i> 京公网安备案11010502037214号</a>| 京网信备  11010519496506010023</p>
		<p class="company_copyright">信息安全管理体系认证 ISO27001 | 管理体系认证 ISO9001 | 信息系统安全等级保护三级 | 公安部安全与警用电子产品质量检测中心 | 国家安全防范报警系统产品质量监督检验中心（北京） </p>
	</div>
    <!-- <div class='footer'>
    	<p class="company_copyright">Copyright&copy; 2013-2020 All Rights Reserved | 版权所有：真相网络科技（北京）有限公司 | 京ICP备16033891号-2 | 公京检第1792001号<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037214"><i></i> 京公网安备案11010502037214号</a>| 京网信备  11010519496506010023</p>
		<p class="company_copyright">公安部安全与警用电子产品质量检测中心 | 国家安全防范报警系统产品质量监督检验中心（北京） </p>
	</div> -->
</template>

<script>
export default {
	name:'FooterArea',
    data(){
        return{
            yearTIme:new Date().getFullYear()
        }
    }
}
</script>

<style scoped>
/* footer */
.footer {
    width: 100%;
    height: auto;
    padding: 25px 0;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    line-height: 24px;
    background: #eee;
}
.footer .company_copyright {
    color:#7c7c7c;
    font-size: 12px;
}
.company_copyright i{
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    background: url(../../assets/images/gongan.png)
}
.company_copyright a{
    color: #7c7c7c;
}
.picture-warning:hover{
    color: #c45;
}
</style>
